import { CheckboxFieldUI } from '@axo/form/feature/form-input/CheckboxField/CheckboxFieldUI';
import { TermsUI } from '@axo/form/feature/terms-and-conditions/src/components/TermsAndConditions/TermsAndConditionsUI';
import { useTranslation } from '@axo/shared/i18n';
import { MarketCountryCode } from '@axo/shared/types';
import { MouseEvent, ReactElement, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { useAxoFormContext } from '../../../context/AxoForm/AxoForm';
import styles from '../Consent.module.scss';
import type { ConsentConfig } from '../hooks/useConsentConfig';
import { ConsentPopupType } from './Marketing';

export const MarketingField = ({
  applicant,
  consentConfig,
  openPopup,
  terms,
  external,
}: {
  applicant: 'main' | 'coapp';
  consentConfig?: ConsentConfig;
  openPopup: (e: MouseEvent, type: ConsentPopupType) => void;
  // TODO: Temporary -> Remove when Sweden is using the new consent config
  terms?: any;
  external?: boolean;
}): ReactElement => {
  const { t } = useTranslation();

  const { marketCountry } = useAxoFormContext();

  const marketingConsentName =
    applicant === 'coapp'
      ? 'Ignore/CoApplicantMarketingConsent'
      : 'Ignore/MarketingConsent';

  const marketingComponents = useMemo(() => {
    let components = [
      <button
        key="services"
        className={styles.term}
        onClick={(e) => openPopup(e, 'services')}
        data-testid="services-button"
        tabIndex={1}
      />,
      <button
        key="partners"
        className={styles.term}
        onClick={(e) => openPopup(e, 'partners')}
        data-testid="partners-button"
        tabIndex={1}
      />,
    ];

    // TODO: Remove when Sweden is using the new consent config
    if (!external && marketCountry === MarketCountryCode.Sweden && terms) {
      components = [
        <TermsUI
          key="customer_club"
          className={styles.term}
          term="customer_club"
          terms={terms}
        />,
      ];
    }

    return components;
  }, [external, marketCountry, openPopup, terms]);

  return (
    <CheckboxFieldUI
      name={marketingConsentName}
      data-testid="marketing-consent-checkbox"
    >
      <Trans
        i18nKey={
          consentConfig?.content
            ? consentConfig.content
            : 'Consent.marketing.description'
        }
        t={t}
        components={marketingComponents}
      />
    </CheckboxFieldUI>
  );
};
